<template>
  <v-flex>
    <v-card :class="cssClass">
      <v-card-title>
        <span class="headline">{{titleDisplay}} ({{conversion.output_format}}<span v-if="conversion.layer">/{{conversion.layer}}</span>) Conversion<span v-if="error"> failed</span></span>
      </v-card-title>

      <v-card-text v-if="conversion.finished">
        <v-card v-if="error" class="red darken-2 white--text" @click.native="showError = !showError">
          <v-card-title>
            <p class="title"><span v-if="showError">Hide</span> <span v-else>Show</span> Error Details</p>
          </v-card-title>
          <v-card-text v-show="showError">
            <p class="break-text" v-html="error"></p>
          </v-card-text>
        </v-card>

        <p class="title">
          Selected Options
        </p>
        <p>
          <span v-if="conversionType">Conversion Type: <strong>{{conversionType}}</strong><br /></span>
          <span v-if="conversion.output_format">Format: <strong>{{conversion.output_format}}</strong><br /></span>
          <span v-if="conversion.layer">Layer: <strong>{{conversion.layer}}</strong><br /></span>
          <span v-if="conversion.input_crs">Source EPSG: <strong>{{conversion.input_crs}}</strong><br /></span>
          <span v-if="conversion.output_crs">Result EPSG: <strong>{{conversion.output_crs}}</strong><br /></span>
          <span v-if="conversion.output_image_width">Image width: <strong>{{conversion.output_image_width}}</strong><br /></span>
          <span v-if="conversion.output_image_height">Image height: <strong>{{conversion.output_image_height}}</strong><br /></span>
        </p>
      </v-card-text>

      <v-card-text v-if="!conversion.finished">
        <v-progress-circular indeterminate v-bind:size="70" v-bind:width="7" class="grey--text"></v-progress-circular>
        <p>
          Please be patient. If this takes very long, consider limiting the layers/input file size
          in the provided url or/and image size.
        </p>
      </v-card-text>

      <v-card-actions v-if="conversion.finished">
        <v-btn
          v-if="conversion.result"
          target="_blank"
          tag="a"
          :href="conversion.result"
          class="green white--text"
        >Download Result</v-btn>

        <v-spacer></v-spacer>

        <v-dialog v-model="showConfirmDialog" lazy absolute>
          <v-btn color="primary" dark slot="activator" class="red lighten-1 white--text">Delete</v-btn>
          <v-card>
            <v-card-title>
              <div class="headline">Delete {{titleDisplay}}?</div>
            </v-card-title>
            <v-card-text>Delete {{conversion.output_format}}<span v-if="conversion.layer">/{{conversion.layer}}</span> Conversion<span v-if="error"> (failed)</span>?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="red lighten-1 white--text" @click.native="remove">Yes</v-btn>
              <v-btn class="white black--text" @click.native="showConfirmDialog = false">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
  export default {
    name: 'conversion-result',
    props: {
      conversionId: {
        required: true,
        type: String,
      },
    },
    data() {
      return {
        showError: false,
        showConfirmDialog: false,
      };
    },
    mounted() {
      this.getData();
    },
    methods: {
      remove() {
        this.$store.dispatch('removeConversion', this.conversion.id);
        this.showConfirmDialog = false;
      },
      getData() {
        this.$store.dispatch('fetchConversion', this.conversion.id);
      },
    },
    computed: {
      cssClass() {
        if (this.error) {
          return 'red lighten-4';
        }
        if (this.error !== null) {
          return 'green lighten-4';
        }
        return 'grey lighten-2';
      },
      conversion() {
        return this.$store.getters.getConversion(this.conversionId);
      },
      error() {
        if (!this.conversion.finished) {
          // We don't know what happened so far, so we return as if everything is OK at this point.
          return null;
        }
        if (!this.conversion.result) {
          return this.conversion.error;
        }
        return false;
      },
      conversionType() {
        if (this.conversion && this.conversion.conversion_type) {
          return this.conversion.conversion_type.toUpperCase();
        }
        return '';
      },
      titleDisplay() {
        if (this.conversion.title) {
          return this.conversion.title.substring(0, 20);
        }
        return '';
      },
    },
  };
</script>
<style scoped>
  .break-text {
    white-space: pre-line;
  }
</style>



// WEBPACK FOOTER //
// src/components/converter/output/ConversionResult.vue